import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import type { AdminCollection } from "./useAdminCollections";

function getAuthedInstance() {
  const token = JSON.parse(localStorage.getItem("token") ?? "null");
  return createPrivateAdminPanelInstance(token?.AccessToken);
}

export async function fetchCollectionDetail(
  code: string,
): Promise<AdminCollection | null> {
  const instance = getAuthedInstance();
  const url = API_ROUTES.GET_ADMIN_COLLECTION.replace(
    "{code}",
    encodeURIComponent(code),
  );
  const { data: responseBody } = await instance.get(url);
  if (responseBody?.success === false) {
    throw new Error(responseBody?.message || "Failed to fetch collection");
  }
  return (responseBody?.data as AdminCollection) ?? null;
}

export function useCollectionDetail(code: string | null) {
  return useQuery({
    queryKey: ["casinoConfiguration", "collections", "detail", code],
    queryFn: () => fetchCollectionDetail(code!),
    enabled: Boolean(code),
  });
}
